import { render, staticRenderFns } from "./homemessage.vue?vue&type=template&id=d404cf00"
import script from "./homemessage.vue?vue&type=script&lang=js"
export * from "./homemessage.vue?vue&type=script&lang=js"
import style0 from "./homemessage.vue?vue&type=style&index=0&id=d404cf00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports